import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';
import React from 'react';

interface AuthCardProps {
  title: string;
  children: React.ReactNode;
}

export const AuthCard: React.FC<AuthCardProps> = ({ title, children }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.palette.mode === 'dark' ? 'none' : theme.shadows[1],
        border: theme.palette.mode === 'dark' ? 'none' : `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
      }}
    >
      {/* Header */}
      <Box sx={{ padding: 2, paddingBottom: 0 }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontFamily: '"Space Grotesk", sans-serif',
            fontSize: '24px',
            fontWeight: 400,
            lineHeight: 1.334,
            color: theme.palette.text.primary,
            marginBottom: 0,
          }}
        >
          {title}
        </Typography>
      </Box>

      <CardContent sx={{ padding: 2 }}>
        {children}
      </CardContent>
    </Card>
  );
}; 